import StarterKit from '@tiptap/starter-kit';

/**
 * What the description may hold (brief §3, decision 3, ADR 0052): paragraphs,
 * bold, bulleted lists and links — the three the toolbar offers, and nothing a
 * keyboard shortcut could add behind its back. The editor and the card's view
 * share this list, so they always read a description the same way.
 *
 * No hard break: Ctrl/Cmd+Enter belongs to the card (it saves), and TipTap
 * binds it to a line break. Enter still starts a new paragraph.
 */
export const DESCRIPTION_EXTENSIONS = [
  StarterKit.configure({
    blockquote: false,
    code: false,
    codeBlock: false,
    hardBreak: false,
    heading: false,
    horizontalRule: false,
    italic: false,
    orderedList: false,
    strike: false,
    underline: false,
    link: {
      openOnClick: false,
      autolink: true,
      defaultProtocol: 'https',
      HTMLAttributes: { target: '_blank', rel: 'noopener noreferrer' },
    },
  }),
];

/**
 * The description's typography, editor and view alike: 14px on 22px lines,
 * paragraphs and lists spaced by 8px, links in the library's blue.
 */
export const DESCRIPTION_LINE_HEIGHT_PX = 22;

export const DESCRIPTION_CONTENT_SX = {
  fontSize: 'var(--font-size-body-regular)',
  lineHeight: `${String(DESCRIPTION_LINE_HEIGHT_PX)}px`,
  color: 'var(--fg-1)',
  overflowWrap: 'anywhere',
  '& p, & ul': { m: 0, mb: 1 },
  '& ul': { pl: 2.5 },
  '& > *:last-child, & .ProseMirror > *:last-child': { mb: 0 },
  '& a': { color: 'var(--color-blue-80)' },
  '& .ProseMirror:focus': { outline: 'none' },
} as const;
